import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
/* --------------------------------------------- */
import { useHistory } from 'react-router-dom'
import useDetailsApi from '../../../../apis/useDetailsApi';
import useLoggly from '../../../../containers/useLoggly';
import { GlobalContext } from '../../../../context/global.context';
import { routeMap } from '../../../../route';
import { splitLanguage } from '../../../../utils/localStorageService';
import _utils from '../../../../utils/utils';
/* --------------------------------------------- */
import Button from "../../../form/Button"
import { InfoTitle, InfoDesc, ButtonWrapper, InfoCtaDesc, InfoSubTitle, ListInfoWrapper } from '../styles'
import "../_landing-page.scss";
import "./_page-type.scss";

/* --------------------------------------------- */
// SubscriptionSection component for showing pageComponent
const SubscriptionSection = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const history = useHistory()
  const { dispatch, appLanguage, isAuthenticated } = useContext(GlobalContext)
  const { sectionData, contentData, homePageRedirectHandler, themeSection: theme = {} } = props
  const { getProductsDetails } = useDetailsApi()
  const [baseUrl, updateBaseUrl] = useState(null)
  const { appConfig } = useSelector(store => store.appConfigReducers)
  const { log } = useLoggly()
  const scrollRef = useRef()
  const [shouldScroll, setShouldScroll] = useState(false)
  const componentData = sectionData
  const { userManagementConfig = {} } = useSelector(store => store.userManagement)
  /* --------------------------------------------- */
  const { loginMethods = [] } = userManagementConfig
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  /**
 * It: Sets baseUrl in a state.
 */
  useEffect(() => {
    if (!appConfig.baseUrl) return
    updateBaseUrl(appConfig.baseUrl)
    if (_utils.isSubscriptionPage()) {
      // dispatch({ type: 'SHOW_SPLASH', value: false })
    }
  }, [appConfig.baseUrl, dispatch])

  const planSelectRedirectHandler = (uri) => {
    dispatch({ type: 'RENDERED_LANDING', value: true })
    if (uri) {
      window.location.href = uri
    } else if ((loginMethods || []).indexOf('vdts') > -1) {
      dispatch({ type: 'SHOW_LOGIN_POPUP' })
      dispatch({
        type: 'LOGIN_POPUP_DETAILS',
        value: {
          isShowCloseIcon: true,
          onCloseClick: () => {
            dispatch({ type: 'HIDE_LOGIN_POPUP' })
          }
        }
      })
    }
    else {
      const params = {
        language: splitLanguage(appLanguage)
      }
      getProductsDetails(baseUrl, uri, params).then((res = {}) => {
        if (res && res.product && res.product.storeProductId) {
          const storeId = res.product.storeProductId
          if (storeId === uri && isAuthenticated) {
            history.push(routeMap.payment.replace(':storeProductId', storeId))
          }
          else if (storeId === uri) {
            history.push({
              pathname: routeMap.signup,
              search: `?uri=${uri}`
            })
          } else {
            history.push(routeMap.signup)
          }
        } else {
          history.push(routeMap.signup)
        }
      }).catch(() => {
        log({
          type: 'Error', attr: {
            event: 'ProductDetailsFailed',
            error_code: 'A-7002',
            error_message: 'product details API failed ProductDetailsFailed',
            error_shown: false,
            pageUrl: window.location.href
          }
        })
        history.push(routeMap.signup)
      })
    }
  }

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  const isOverflown = ({ clientWidth, scrollWidth, childElementCount }) => {
    if (clientWidth < 480) return true
    else return clientWidth > 0 && scrollWidth >= clientWidth && childElementCount > 4;
  }

  useEffect(() => {
    const resizeEvent = () => {
      if (scrollRef.current) {
        setShouldScroll(isOverflown(scrollRef.current))
      }
    }
    resizeEvent();
    window.addEventListener('resize', resizeEvent)
    return () => {
      window.removeEventListener('resize', resizeEvent)
    }
  }, [])

  const ctaDataInfo = (
    <div style={{ textAlign: 'center' }}>
      {
        componentData?.ctaDescription && (
          <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc'>{componentData.ctaDescription}</InfoCtaDesc>
        )
      }
      {
        componentData?.ctaData && (
          <ButtonWrapper {...{ theme }}>
            <Button {...{ title: componentData.ctaData }} onClick={homePageRedirectHandler} />
          </ButtonWrapper>
        )
      }
    </div>
  )
  const onImageLoad = () => {
    setShouldScroll(isOverflown(scrollRef.current))
  }
  return (
    <>
      <div className="plan-component" ref={scrollRef} style={shouldScroll ? {} : { justifyContent: 'center' }} >
        {
          contentData.map((data, idx) => {
            const { title, description, ctaData, ctaDescription, graphics: { img }, listData, params, data: uri } = data
            // const amountInfo = params?.split(",")
            return (
              <div className="plan-section" key={idx}>
                <img src={img} alt="subscription-plan" onLoad={() => onImageLoad()} />
                <div className='info-wrapper'>
                  {
                    title && (
                      <InfoTitle {...{ theme }} className='infoSection__title'>{title}</InfoTitle>
                    )
                  }
                  {
                    description && (
                      <InfoDesc {...{ theme }} className='infoSection__desc'>{description}</InfoDesc>
                    )
                  }
                  {
                    params && (
                      <InfoSubTitle {...{ theme }} className='infoSection__subtitle'>{params}</InfoSubTitle>
                    )
                  }
                  <ListInfoWrapper {...{ noOfLines: listData?.length}}>
                    {listData && listData.map((list, index) => (
                      <p className="list-info" key={index}>{list.label}</p>
                    )
                    )}
                  </ListInfoWrapper>
                </div>
                <div style={{ textAlign: 'center', paddingBottom: '20px' }}>
                  {
                    ctaData && (
                      <ButtonWrapper {...{ theme }}>
                        <Button {...{ title: ctaData }} onClick={() => planSelectRedirectHandler(uri)} />
                      </ButtonWrapper>
                    )
                  }
                  {
                    ctaDescription && (
                      <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc'>{ctaDescription}</InfoCtaDesc>
                    )
                  }
                </div>
              </div>
            )
          })
        }
      </div>
      {ctaDataInfo}
    </>
  )
}


/* --------------------------------------------- */
SubscriptionSection.propTypes = {

}
/* --------------------------------------------- */
SubscriptionSection.defaultProps = {

}
/* --------------------------------------------- */
export default SubscriptionSection